import { render, staticRenderFns } from "./PcfSzervezetek.vue?vue&type=template&id=3af94191&"
import script from "./PcfSzervezetek.vue?vue&type=script&lang=js&"
export * from "./PcfSzervezetek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports